import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../Icon";
import styles from "./NoEmailWarningModal.module.scss";

interface INoEmailWarningModalProps {
    paymentMethod: string;
    onEnterEmail: () => void;
    onPayWithCard: () => void;
    onPayWithApple: () => void;
    disablePayment?: boolean;
}

const NoEmailWarningModal: React.FC<INoEmailWarningModalProps> = ({
    paymentMethod,
    onEnterEmail,
    onPayWithCard,
    onPayWithApple,
    disablePayment = false,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles.warningOverlay}>
            <div className={styles.warningOverlayContainer}>
                <p className={styles.warningOverlayText}>{t("buy.noEmailWarning")}</p>

                <div className={styles.warningButtons}>
                    <button
                        type="button"
                        onClick={onEnterEmail}
                        className={`${styles.buyButton} ${styles.emailButton} ${styles.buttonFull}`}
                    >
                        {t("buy.enterEmail")}
                    </button>

                    {(paymentMethod === "Card" || paymentMethod === "CardToken") && (
                        <button type="button" onClick={onPayWithCard} className={`${styles.buyButton} ${styles.buttonFull}`}>
                            <Icon.PaymentCard className={styles.actionIcon} size={18} />
                            &nbsp;&nbsp;{t("buy.payByCard")}
                        </button>
                    )}

                    {paymentMethod === "ApplePay" && (
                        <button
                            disabled={disablePayment}
                            type="button"
                            onClick={onPayWithApple}
                            className={`${styles.buyButton} ${styles.appleButton} ${styles.buttonFull}`}
                        >
                            <Icon.ApplePay className={styles.appleIcon} size={16} />
                            &nbsp;Pay with Apple
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NoEmailWarningModal;
